import { useGetSpace, useSpaceCheckinMutation } from '@onesource/services';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';

import { SubNavPageContainer } from '../../../../../components/page-container';
import { PreviewModeBanner } from '../../../../../features/community-hub/components/preview-mode-banner';
import { PreviewModeProvider } from '../../../../../features/community-hub/hooks/use-preview-mode';

export const Route = createFileRoute('/_protected/community-hub/spaces/$id')({
  component: SpaceRouteWrapper,
});

function SpaceRouteWrapper() {
  const { id } = Route.useParams();
  const { mutate: checkin } = useSpaceCheckinMutation();
  // The top-level space carries the `app` key; preview is gated on the user's
  // role for that app (matching the backend's userCanReviewSpace).
  const { data: space } = useGetSpace(id);

  useEffect(() => {
    checkin(id);
  }, [id]);

  return (
    <PreviewModeProvider app={space?.app}>
      <SubNavPageContainer>
        <PreviewModeBanner />
        <Outlet />
      </SubNavPageContainer>
    </PreviewModeProvider>
  );
}
